module.exports = __webpack_public_path__ + "media/trubadur.b2d86c48.webm";